export function getIsReady(client) {
    return client.__context.get(client.__context.constants.READY, true)
        ? true
        : false;
}
export function getIsReadyFromCache(client) {
    return client.__context.get(client.__context.constants.READY_FROM_CACHE, true)
        ? true
        : false;
}
export function getHasTimedout(client) {
    return client.__context.get(client.__context.constants.HAS_TIMEDOUT, true)
        ? true
        : false;
}
export function getIsDestroyed(client) {
    return client.__context.get(client.__context.constants.DESTROYED, true)
        ? true
        : false;
}
export function getStatus(client) {
    var isReady = client ? getIsReady(client) : false;
    var hasTimedout = client ? getHasTimedout(client) : false;
    return {
        isReady: isReady,
        isReadyFromCache: client ? getIsReadyFromCache(client) : false,
        isTimedout: hasTimedout && !isReady,
        hasTimedout: hasTimedout,
        isDestroyed: client ? getIsDestroyed(client) : false
    };
}
var internalUserEmailDomains = ['@luc.id', '@federatedsample.com'];
export var isInternalUser = function (email) {
    return internalUserEmailDomains.some(function (domain) { return email.toLowerCase().endsWith(domain); });
};
//# sourceMappingURL=utils.js.map